import ApiManager from '../index';
import store from '../../redux';
import actions from '../../redux/actions';
import AppConfig from '../../app/config/AppConfig';
import { getEnviormentUrls, removeProtocolFromUrl } from '../../app/functions';




class Api extends ApiManager {
    constructor() {
        if(!Api.instance) {
            super();
            Api.instance = this;
        }
        
        // App config
        this.config = new AppConfig();

        return Api.instance = this;
    }

    getHostUrl = async (props = {}) => {
        
        const { apiHost, apiGetHost } = getEnviormentUrls();
        const onSuccess = () => {
            const apiParams = {
                base_url: removeProtocolFromUrl(apiHost),
                get_url: removeProtocolFromUrl(apiGetHost),
                get_methods: [
                    "generalDeclaration",
                    "lightGd"
                  ],
            };

            this._updateApiParams(apiParams);
        };

        onSuccess();
    }

    generalDeclaration = (props = {}) => {
        const onSuccess = (response) => {
            store.dispatch(actions.setGd(response.data));
        };

        if (window.GeneralDeclaration) {
            return new Promise((resolve) => resolve(
                onSuccess(window.GeneralDeclaration)
            ));
        }

        return this._execute(props, this.config.api.requests.generalDeclaration, onSuccess);
    }

    getInsurancePage = (props = {}) => {
        const onSuccess = (response) => {
            store.dispatch(actions.setInsurancePage(response.data));
        };

        return this._execute(props, this.config.api.requests.getInsurancePage, onSuccess);
    }

    createInsuranceLead = (props = {}, onSuccess) => {
        return this._execute(props, this.config.api.requests.createInsuranceLead, onSuccess);
    }
}

const apiInstance = Object.freeze(
    new Api()
);

export default apiInstance;
